var _style, _g, _ellipse, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrupoPlnatilla(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72.5 72.3",
    style: {
      enableBackground: "new 0 0 72.5 72.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:none;stroke:#F47B33;stroke-width:2;}\r\n\t.st2{fill:#FFDFCC;}\r\n\t.st3{fill:#F47B33;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#C65A1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elipse_47"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 36.2,
    cy: 36.1,
    rx: 35,
    ry: 35.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 36.2,
    cy: 36.1,
    rx: 34,
    ry: 34.5
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_46",
    className: "st2",
    cx: 35.7,
    cy: 36.1,
    rx: 29.5,
    ry: 30.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "folder",
    transform: "translate(17.137 20.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_263",
    className: "st3",
    d: "M33.1,29.7H3.5c-0.9,0-1.7-0.8-1.7-1.7V9.8c0-0.9,0.8-1.7,1.7-1.7h29.6 c0.9,0,1.7,0.8,1.7,1.7V28C34.8,28.9,34.1,29.7,33.1,29.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_264",
    className: "st3",
    d: "M32.6,8.1V6.3c0-0.9-0.8-1.7-1.7-1.7l0,0H15.2c-0.2,0-0.4-0.1-0.5-0.2l-2.2-2.8 c-0.2-0.3-0.5-0.4-0.9-0.4H5.8C4.9,1.2,4.1,2,4.1,2.9l0,0v5.1H32.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_509",
    transform: "translate(0.569 0.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_265",
    className: "st4",
    d: "M3,27.4V9.2c0-0.9,0.8-1.7,1.7-1.7H3C2,7.5,1.2,8.2,1.2,9.2v18.2c0,0.9,0.8,1.7,1.7,1.7h1.7 C3.7,29.1,3,28.3,3,27.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_266",
    className: "st4",
    d: "M6.9,0.6H5.2c-0.9,0-1.7,0.8-1.7,1.7l0,0v5.1h1.7V2.4C5.2,1.4,6,0.6,6.9,0.6L6.9,0.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_510",
    transform: "translate(27.895 3.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_267",
    className: "st5",
    d: "M5.2,4.1H3.5c0.9,0,1.7,0.8,1.7,1.7l0,0V24c0,0.9-0.8,1.7-1.7,1.7l0,0h1.7 c0.9,0,1.7-0.8,1.7-1.7l0,0V5.8C6.9,4.8,6.2,4.1,5.2,4.1L5.2,4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_268",
    className: "st5",
    d: "M3,0.6H1.2C2.2,0.6,3,1.4,3,2.4v0v1.7h1.7V2.4C4.7,1.4,3.9,0.6,3,0.6L3,0.6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_511",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_269",
    d: "M31.4,12h-9.1c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6l0,0h9.1c0.3,0,0.6,0.3,0.6,0.6S31.7,12,31.4,12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_270",
    d: "M31.4,14.3h-4.6c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6h4.6c0.3,0,0.6,0.3,0.6,0.6S31.7,14.3,31.4,14.3 "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_271",
    d: "M33.1,30.3H3.5c-1.3,0-2.3-1-2.3-2.3v-8c0-0.3,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6l0,0v8 c0,0.6,0.5,1.1,1.1,1.1h29.6c0.6,0,1.1-0.5,1.1-1.1V9.8c0-0.6-0.5-1.1-1.1-1.1H3.5c-0.6,0-1.1,0.5-1.1,1.1v5.7 c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6V9.8c0-1.3,1-2.3,2.3-2.3h29.6c1.3,0,2.3,1,2.3,2.3V28 C35.4,29.2,34.4,30.2,33.1,30.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_272",
    d: "M2.4,17.7c0,0.3-0.3,0.6-0.6,0.6S1.2,18,1.2,17.7s0.3-0.6,0.6-0.6S2.4,17.4,2.4,17.7L2.4,17.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_273",
    d: "M4.7,7.5H32V6.3c0-0.6-0.5-1.1-1.1-1.1H15.2c-0.4,0-0.7-0.2-0.9-0.4L12.1,2c-0.1-0.1-0.3-0.2-0.4-0.2 H5.8c-0.6,0-1.1,0.5-1.1,1.1L4.7,7.5z M32.6,8.6H4.1c-0.3,0-0.6-0.3-0.6-0.6l0,0V2.9c0-1.3,1-2.3,2.3-2.3h5.8c0.5,0,1,0.2,1.3,0.6 L15.2,4l15.7,0c1.3,0,2.3,1,2.3,2.3v1.7C33.1,8.4,32.9,8.6,32.6,8.6L32.6,8.6L32.6,8.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupoPlnatilla);
export default __webpack_public_path__ + "static/media/grupo_plnatilla.891ece81.svg";
export { ForwardRef as ReactComponent };